import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import initialStateReducer from './initialStateReducer';

export default (history) =>
  combineReducers({
    router: connectRouter(history),
    initialState: initialStateReducer,
  });
